
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import { getModule } from "vuex-module-decorators";
import { SystemModule } from "@/store/modules";


@Component({
  components: {
    Select
  }
})
export default class AgentFacilitySelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  systemModule = getModule(SystemModule);

  @Prop({ default: false })
  appendToBody: boolean;
  @Prop()
  type: string;
  @Prop({ default: false })
  isInactiveIncludeFacilities: boolean;
  
  @Prop({ default: null })
  deliveryForId: number;

  isInit: boolean = false;

  mounted() {
    this.deliveryForChanged()
  }

  @Watch("deliveryForId")
  deliveryForChanged() {
    this.systemModule.loadAgentFacilities(this.deliveryForId);  
  }

  get types() {
    const facilityList = this.systemModule.agentFacilities;
    return facilityList.filter(item => item.facilityCode).map(x => ({ label: `${this.getActiveText(x.isActive)} ${this.getFacilityNameText(x.name)} (${x.facilityCode})`, value: x.facilityCode, isActive: x.isActive }));
  }

  getFacilityNameText(facilityName) {
    return facilityName || 'Facility name not available';
  }

  getCompanyNameText(companyName) {
    return companyName || 'Company name not available';
  }

  getActiveText(isActive) {
    return isActive ? '' : 'Inactive ';
  }
}
